/**
 * 接口
 */
import config from '@/config/index.js';

const fellows = ({ fellow_email }) => {
    return {
        url: `/uds/ss/fellow/v1/fellows/${fellow_email}`,
        method: 'get'
    };
};
// 发送验证码
const sendVerificationCode = {
    url: '/acc/2/in/verification_code/send',
    method: 'post',
    contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
};

// 查看分享详情
const share = {
    url: `/uds/ss/fellow/v1/fellows/shares`,
    method: 'get'
};
// 提交试车信息
const collect = {
    url: `/uds/ss/fellow/v1/fellows/shares/collect`,
    method: 'post'
};
// 查询分享描述
const descriptionsList = {
    url: `/uds/ss/fellow/v1/fellows/shares/descriptions`,
    method: 'get'
};
// 查询车类型
const productsList = {
    url: `/uds/ss/fellow/v1/fellows/shares/products`,
    method: 'get'
};
// 查询车类型
const wxConfigSig = {
    url: `/index/wxConfigSig`,
    method: 'get'
};
// 试驾单
const testDriveOrders = {
    // url: '/uds/ss/drive/v1/test-drive-orders',
    url: '/beyonder/api/v3/test-drive-orders/by-mobile-verify',
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};
// 查询试驾单
const userIdentityTestDriveStatus = {
    url: '/beyonder/api/v1/test-drive-orders/user-identity-test-drive-status',
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

/**
 * 查询试驾单
 * uds/in/drive/v1/test-drive-orders
 */
const testDriveOrderList = {
    url: `/beyonder/api/v1/user/test-drive-orders`,
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

const testDriveWhiteList = {
    url: `/beyonder/api/v1/config/whitelist?node=testdrive_cities`,
    method: 'get'
};

const userIdentityTestDriveByOrderNoV2 = {
    url: `/beyonder/api/v2/test-drive-orders/{order_no}`,
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 试驾单 详情
const userIdentityTestDriveByOrderNo = {
    url: '/beyonder/api/v1/test-drive-orders/{order_no}',
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// app登陆创建-试驾单
const testDriveOrdersByLoginUser = {
    // url: '/uds/ss/drive/v1/test-drive-orders',
    url: '/beyonder/api/v2/test-drive-orders/by-login-user',
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 请求
const configCar = {
    url: `/beyonder/api/v1/config/car`,
    method: 'get',
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 获取account
const getAccount = {
    url: `uds/in/user/v2/users/accounts/{account_id}`,
    method: 'get',
    serverHost: '/'
};

const userInviteable = {
    url: '/beyonder/api/v1/user/inviteable',
    method: 'get',
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

const inviterInfo = {
    url: '/beyonder/api/v1/inviters/info',
    method: 'get',
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

// 获取account
const checkCode = {
    url: `/checkCode`,
    method: 'get',
    serverHost: '/api/test'
};

// 获取图形码
// [20240704] 移除帮好友试驾图形码校验逻辑 @TODO: beyonder接口下线
// const captchaImg = {
//     url: `/beyonder/api/v1/captcha`,
//     method: 'get',
//     requstTypeJson: true,
//     mergeData: {
//         wx_app_id: config.wx_app_id
//     }
// };

/** 代好友预约试驾 获取邀请验证码 */
const getReferralVerificationCode = {
    url: `/proxy/seige/v1/in/referral-test-drive/verification-code`,
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};
/** 代好友预约试驾 预约单列表 https://apidoc.nioint.com/project/11730/interface/api/1278002 */
const getReferralInviteRecordList = {
    url: `/proxy/seige/v1/in/referral-test-drive/order/list`,
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

/**
 * 根据token获取关联信息
 */
const tokenInfo = {
    url: `/beyonder/api/v2/leads/token-info`,
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};
/**
 * 创建好友邀请关系
 */
const createFriendsInvitation = {
    url: `/beyonder/api/v2/leads/invitation`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};
/**
 * 帮好友预约试驾v2 包含下面两个接口
 * [20240704] 帮好友预约试驾页面调整 保留接受接口for短信跳转兼容
 */
// （发起接口）帮好友预约试驾
// const createFriends = {
//     url: `/beyonder/api/v3/leads/friends`,
//     method: 'post',
//     requstTypeJson: true,
//     mergeData: {
//         wx_app_id: config.wx_app_id
//     }
// };

// 代好友预约试驾
const createFriendTestDrive = {
    url: `/proxy/seige/v1/in/referral-test-drive/register`,
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};

// （接受接口）接受好友预约试驾
const createFriendsInvitationV2 = {
    url: `/beyonder/api/v3/leads/invitation`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

/**
 * 取消 试驾单
 */
const testDriveOrdersCancel = {
    url: `/beyonder/api/v2/test-drive-orders/cancel`,
    method: 'post',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

/**
 * 用户信息
 */
const leadsInfo = {
    url: `/beyonder/api/v2/leads/info`,
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

/**
 * 来源codes
 */
const getCompatibleCode = {
    url: `/compatibleCode`,
    method: 'get',
    serverHost: '/backend'
};

const getDrivingAddressDetail = {
    url: `/driving/address/detail`,
    method: 'post',
    requstTypeJson: true,
    serverHost: '/backend'
};

const getDrivingAddressList = {
    url: '/beyonder/api/v1/geo/driving/address/list',
    method: 'get',
    requstTypeJson: true,
    mergeData: {
        wx_app_id: config.wx_app_id
    }
};

const rgeo = {
    url: `/rgeo`,
    method: 'post',
    requstTypeJson: true,
    serverHost: '/backend'
};

/** 获取fellow专属下载链接 https://apidoc.nioint.com/project/11730/interface/api/1384816 */
const getFellowDownloadUrl = {
    url: `/proxy/seige/v1/in/fellow/download-code`,
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

/** 常规留资专用encodeUniqueKey 但是试驾的参数一模一样，也用用 */
const encodeLeadsUniqueKey = {
    url: '/tools/v1/unique-key/encode/leads',
    method: 'post',
    requstTypeJson: true,
    serverHost: '/dino'
};

/** decode uniqueKey */
const decodeUniqueKey = {
    url: '/tools/v1/unique-key/decode',
    method: 'get',
    requstTypeJson: true,
    serverHost: '/dino'
};

export default {
    fellows,
    sendVerificationCode,
    share,
    collect,
    descriptionsList,
    productsList,
    wxConfigSig,
    testDriveOrders,
    configCar,
    getAccount,
    userInviteable,
    inviterInfo,
    checkCode,
    getReferralVerificationCode,
    getReferralInviteRecordList,
    tokenInfo,
    createFriendTestDrive,
    createFriendsInvitation,
    createFriendsInvitationV2,
    testDriveOrderList,
    testDriveOrdersByLoginUser,
    testDriveOrdersCancel,
    testDriveWhiteList,
    leadsInfo,
    getCompatibleCode,
    userIdentityTestDriveStatus,
    userIdentityTestDriveByOrderNo,
    userIdentityTestDriveByOrderNoV2,
    getDrivingAddressDetail,
    getDrivingAddressList,
    rgeo,
    decodeUniqueKey,
    encodeLeadsUniqueKey,
    getFellowDownloadUrl
};



// WEBPACK FOOTER //
// ./src/service/driver/index.js